import { get } from 'lodash-es';

export const OldWebviewEvents = {
  goBackToMenu() {
    const backToApp = get(window, 'AviataApp.backToApp', () => ({}));
    backToApp();
  },
};
